import React, { Component } from "react";
import Accordion from "../../accordion";
import commonContext, { AppContext } from "../../../context/common";
import { leadType } from "../../../../app";
import { Utilities } from "../../../utils/utilities";
import RadioForm from "../../html/radioForm";

interface IProps {}
interface IState {}
export class MotorInsurance extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    utils: Utilities;
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        this.setLead({
            motorInsuranceQ1: "Yes",
            motorInsuranceQ2: "Yes",
            motorInsurancePremium: this.lead.motorInsurancePremiumAmountY,
            motorInsurancePremiumEditAmount: this.lead
                .motorInsurancePremiumAmountY,
            motorInsuranceClaimed: true,
        });
    }
    handleOnChange = async (e) => {
        this.lead = (this.context as AppContext).lead as leadType;
        let amount = "0",
            availed = true,
            motorInsuranceClaimed = false;

        if (
            this.lead.motorInsuranceQ1 == "Yes" &&
            this.lead.motorInsuranceQ2 == "Yes"
        ) {
            amount = this.lead.motorInsurancePremiumAmountY;
            motorInsuranceClaimed = true;
        }
        if (
            this.lead.motorInsuranceQ1 == "Yes" &&
            this.lead.motorInsuranceQ2 == "No"
        ) {
            amount = this.lead.motorInsurancePremiumAmountN;
        }
        if (
            this.lead.motorInsuranceQ1 == "No" &&
            this.lead.motorInsuranceQ2 == "No"
        ) {
            availed = false;
        }
        if (this.lead.motorInsuranceQ1 == "No") {
            availed = false;
        }
        await this.setLead({
            motorInsuranceAvailed: availed,
            motorInsurancePremium: amount,
            motorInsurancePremiumEditAmount: amount,
            motorInsuranceClaimed: motorInsuranceClaimed,
        });
    };
    render() {
        this.utils = (this.context as AppContext).utils as Utilities;
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="container mx-auto px-0 md:px-5">
                    <div className="relative w-full">
                        <div className="accord-wrap">
                            <Accordion open={true} title="Motor Insurance">
                                <div className="w-full">
                                    <div className="flex flex-wrap my-3">
                                        <div className="relative w-full mb-2 md:mb-3">
                                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                                Do you wish to avail future
                                                dated Nil Depreciation Motor
                                                Insurance (Bumper to Bumper
                                                cover) policy at a nominal price
                                                with upfront No Claim Bonus?
                                            </label>
                                            <div className="custom-inputs mt-4 mb-6 md:mb-8 openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                                <label className="inline-flex items-center">
                                                    <RadioForm
                                                        label="Yes"
                                                        name="motorInsuranceQ1"
                                                        value="Yes"
                                                        checked={
                                                            this.lead
                                                                .motorInsuranceQ1 ==
                                                            "Yes"
                                                                ? true
                                                                : false
                                                        }
                                                        onChange={(e) =>
                                                            this.handleOnChange(
                                                                e
                                                            )
                                                        }
                                                    />
                                                </label>
                                                <label className="inline-flex items-center ml-6">
                                                    <RadioForm
                                                        label="No"
                                                        name="motorInsuranceQ1"
                                                        value="No"
                                                        checked={
                                                            this.lead
                                                                .motorInsuranceQ1 ==
                                                            "No"
                                                                ? true
                                                                : false
                                                        }
                                                        onChange={(e) =>
                                                            this.handleOnChange(
                                                                e
                                                            )
                                                        }
                                                    />
                                                </label>
                                            </div>
                                            <span className="hidden error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm">
                                                Please select
                                            </span>
                                        </div>
                                        {this.lead.motorInsuranceQ1 == "Yes" ? (
                                            <>
                                                <div className="relative w-full mb-2 md:mb-3">
                                                    <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                                        Have you made an
                                                        Insurance Claim in your
                                                        current insurance?
                                                    </label>
                                                    <div className="custom-inputs mt-4 mb-6 md:mb-8 openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                                        <label className="inline-flex items-center">
                                                            <RadioForm
                                                                label="Yes"
                                                                name="motorInsuranceQ2"
                                                                value="Yes"
                                                                checked={
                                                                    this.lead
                                                                        .motorInsuranceQ2 ==
                                                                    "Yes"
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) =>
                                                                    this.handleOnChange(
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                        </label>
                                                        <label className="inline-flex items-center ml-6">
                                                            <RadioForm
                                                                label="No"
                                                                name="motorInsuranceQ2"
                                                                value="No"
                                                                checked={
                                                                    this.lead
                                                                        .motorInsuranceQ2 ==
                                                                    "No"
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) =>
                                                                    this.handleOnChange(
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                        </label>
                                                    </div>
                                                    <span className="hidden error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm">
                                                        Please select
                                                    </span>
                                                </div>
                                                <div className="relative w-full mb-3 inline-block">
                                                    <p className="grayshade-2 openSans-Reg text-base sm:text-lg md:text-xl mr-3 md:mr-4 mr-5 w-full mb-2">
                                                        Motor Insurance Premium
                                                    </p>
                                                    <div className="w-full openSans-SemiBold w-full">
                                                        <span className="text-base md:text-2xl WebRupee">
                                                            Rs.
                                                        </span>
                                                        <p className="text-base md:text-2xl ml-2 leading-normal inline-block">
                                                            {this.utils.currencyFormat(
                                                                this.lead
                                                                    .motorInsurancePremium
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default MotorInsurance;
